import React from 'react';
import {FormField as FormFieldType, FormData, FormErrors} from '../../../../../types/ContactForm';

interface CheckboxFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
                                                                field,
                                                                formData,
                                                                errors,
                                                                onInputChange,
                                                                onFieldFocus
                                                            }) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    if (field.options) {
        const checkboxOptions = field.options.split('\n').map(opt => opt.trim()).filter(opt => opt);
        const selectedValues = formData[field.name] || [];

        return (
            <div className={`col-12 col-md-${field.width || 12} zr-input-checkbox`}>
                <div className={`${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                    <fieldset>
                        <legend className="control-label">
                            {field.label}
                        </legend>
                        {checkboxOptions.map((option, index) => (
                            <div key={index} className="form-check">
                                <input
                                    type="checkbox"
                                    id={`field-${field.id}-${index}`}
                                    name={field.name}
                                    value={option}
                                    className="form-check-input"
                                    checked={Array.isArray(selectedValues) && selectedValues.includes(option)}
                                    onChange={(e) => {
                                        const currentValues = Array.isArray(formData[field.name]) ? formData[field.name] : [];
                                        if (e.target.checked) {
                                            handleInputChange([...currentValues, option]);
                                        } else {
                                            handleInputChange(currentValues.filter((val: string) => val !== option));
                                        }
                                    }}
                                />
                                <label htmlFor={`field-${field.id}-${index}`}
                                       className="form-check-label">{option}</label>
                            </div>
                        ))}
                    </fieldset>
                    {errors[field.name] && (
                        <div className="form-error-msg text-danger">
                            <i className="fa fa-warning"></i> {errors[field.name]}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className={`col-12 col-md-${field.width || 12}`}>
            <div
                className={`form-group ${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <div className="form-check">
                    <input
                        type="checkbox"
                        id={`field-${field.id}`}
                        name={field.name}
                        className="form-check-input"
                        checked={formData[field.name] || false}
                        onChange={(e) => handleInputChange(e.target.checked)}
                        aria-required={field.required}
                    />
                    <label htmlFor={`field-${field.id}`} className="form-check-label">
                        {field.label}
                    </label>
                </div>
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

